import React, {useEffect, useState} from 'react';

import styles from './DesktopCartPage.module.css'

import {DesktopCartProducts} from "../../components/CartProducts/Desktop/DesktopCartProducts.tsx";
import {DesktopCartDelivery} from "../../components/CartDelivery/Desktop/DesktopCartDelivery.tsx";
import {CartPaymentMethods} from "../../components/CartPaymentMethods/CartPaymentMethods.tsx";
// import {CartExtraInfo} from "../../components/CartExtraInfo/CartExtraInfo.tsx";
import {CartOrder} from "../../components/CartOrder/CartOrder.tsx";
import {Address} from "../../../../types/Delivery.interface.ts";
import {Order} from "../../../../types/Order.interface.ts";
import {LoginWarning} from "../../../../widgets/LoginWarning/LoginWarning.tsx";
import { CartNotAvailableProducts } from '../../components/CartProducts/components/CartNotAvailableProducts/CartNotAvailableProducts.tsx';

interface Props {
    cartOffer: Order|null,
    isAuth: boolean,
    onPaymentMethodChange: (variant: string) => void,
    onDeliveryTypeChange: (type: string) => void,
    onDeliveryAddressChange: (address: Address, isUpdate: boolean , changeBranch: boolean, deliveryType: string|null) => void,
    onDeliveryTransportCompanyChange: (transportCompanyId: number) => void,
    createOrder: (withBonuses: boolean) => Promise<Response>,
    addOrLessenProduct: (elementId: number, operation: ProductOperation) => void,
    removeProducts: (ids: number[]) => void,
    setIsBranchShown: (isBranchShown: boolean) => void,
    setIsOpenChangeTownModal: (isOpenChangeTownModal: boolean) => void,
}

type ProductOperation = 'add' | 'remove'

export const DesktopCartPage: React.FC<Props> = ({
                                                     cartOffer,
                                                     onPaymentMethodChange,
                                                     onDeliveryTypeChange,
                                                     onDeliveryAddressChange,
                                                     onDeliveryTransportCompanyChange,
                                                     createOrder,
                                                     addOrLessenProduct,
                                                     removeProducts,
                                                     setIsBranchShown,
                                                     setIsOpenChangeTownModal,
                                                     isAuth,
                                                 }) => {
    const [showWarning, setShowWarning] = useState<boolean>(false);
    useEffect(() => {

    }, [cartOffer]);

    return (<>
        {!isAuth && <LoginWarning />}
        <h2 className={styles.title}>Товары в корзине</h2>
        {cartOffer && (<CartNotAvailableProducts productsNotAvailableCount={cartOffer.products.filter(({isAvailable}) => !isAvailable).length} showWarning={showWarning}/>)}
        <div className={styles.wrapper}>
            <div className={styles.mainColumn}>
                {cartOffer ? <DesktopCartProducts
                    addOrLessenProduct={addOrLessenProduct}
                    removeProducts={removeProducts}
                    setShowWarning={setShowWarning}
                    cartId={cartOffer.cartId}
                    cartProducts={cartOffer.products}
                /> : null}
                {
                    cartOffer
                        ? <DesktopCartDelivery
                            offer={cartOffer}
                            onDeliveryTypeChange={onDeliveryTypeChange}
                            onDeliveryAddressChange={onDeliveryAddressChange}
                            onDeliveryTransportCompanyChange={onDeliveryTransportCompanyChange}
                            setIsBranchShown={setIsBranchShown}
                            setIsOpenChangeTownModal={setIsOpenChangeTownModal}
                        />
                        : null
                }
                <CartPaymentMethods onMethodChange={onPaymentMethodChange} cartOffer={cartOffer}/>
                {/* <CartExtraInfo/> */}
            </div>

            {
                cartOffer
                    ? <CartOrder
                        isAuth={isAuth}
                        createOrder={createOrder}
                        onDeliveryAddressChange={onDeliveryAddressChange}
                        setIsOpenChangeTownModal={setIsOpenChangeTownModal}
                    />
                    : null
            }
        </div>
    </>);
};